import type { RawParams } from "@uirouter/core";

import type { SignalsRoutingParams } from "app/pages/sales-intelligence/sub-modules/signals/types";

import { getSignalsDigestParams } from "./signalsDigest";

export const getSignalsRoutingParams = (routeParams: RawParams): Partial<SignalsRoutingParams> => {
    if (routeParams.signalId && !routeParams.digestType) {
        return routeParams;
    }

    return getSignalsDigestParams(routeParams);
};
